import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "inline-block float-left" }
const _hoisted_2 = { class: "font-bold" }
const _hoisted_3 = { class: "inline-block float-right" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.title), 1)
    ]),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.duration), 1),
    _hoisted_4,
    _createElementVNode("div", null, _toDisplayString(_ctx.companyName) + ", " + _toDisplayString(_ctx.address), 1)
  ]))
}